/* eslint-disable */
import { withStyles } from '@material-ui/core';
import React from 'react';
import compose from 'recompose/compose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import FormPropTypes from './Form.component.props';
import formStyles from './Form.component.styles';

/**
 * FormComponent
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const FormComponent = ({ children, onSubmit }) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(e);
      }}
    >
      {children}
    </form>
  );
};

FormComponent.propTypes = FormPropTypes;

const Form = compose(withStyles(themeCreateInjectableStyles(formStyles), { withTheme: true }))(FormComponent);

export default Form;
